import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { IndicadorClienteEditarComponent } from "./indicador-cliente-editar.component"; 
import { FormsModule } from "@angular/forms";
import { IndicadorClienteEditarRoutingModule } from "./indicador-cliente-editar-routing.module";
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from "primeng/progressspinner";

@NgModule({
    imports: [
        CommonModule,            
        IndicadorClienteEditarRoutingModule,
        FormsModule,     
        ButtonModule,
        InputTextModule,
        MessagesModule,
        ProgressSpinnerModule
    ],
    declarations: [IndicadorClienteEditarComponent]
})
export class IndicadorClienteEditarModule { }
